export default __webpack_public_path__ + "static/media/addon6.6a10ca00.webp";